import React from 'react';
import { AppContext } from '../../App';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { labels } from '../../data/labels';
import FastbetAmount from './FastbetAmount';

function FastbetPopup(props) {
    const appContext = React.useContext(AppContext);
    const betslipContext = React.useContext(BetslipContext);

    function toggleFastbetPopup() {
        appContext.toggleFastbetPopup();
    }

    const fastbetEnabled = betslipContext.isAddAndBetEnabled();

    return (
        <div className="customPopup">
            <div className="customPopup__content">
                <div className="customPopup__content__header">
                    <div className="customPopup__content__header__title">
                        <p className="bianco">{fastbetEnabled ? labels['live.fastbet_popup.change_amount'] : labels['live.fastbet_popup.title']}</p>
                    </div>
                    <button className="customPopup__content__header__closeButton" onClick={toggleFastbetPopup}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>
                <div className="customPopup__content__body">
                    {betslipContext.isAddAndBetEnabled() ?
                        <FastbetAmount />
                        :
                        <>
                            <p>{labels['live.fastbet_popup.message']}</p>
                            <hr />
                            <FastbetAmount />
                        </>
                    }
                 </div>
            </div>
        </div>
    );
}

export default FastbetPopup;